import { customElement, FASTElement } from '@genesislcap/web-core';
import { HelpMenuTemplate as template } from './help-menu.template';
import { HelpMenuStyles as styles } from './help-menu.styles';
import { HelpDialog } from '../../../components/help-dialog/help-dialog';

const name = 'help-menu';

@customElement({
  name,
  template,
  styles
})
export class HelpMenu extends FASTElement {

  public helpDialog: HelpDialog;

  public showHelp() {
    this.helpDialog.show();
  }
}
